import React, { memo } from 'react';
import { ShieldCheckIcon, ThumbsUpIcon, HeartIcon, TrophyIcon, StarIcon, BriefcaseIcon } from 'lucide-react';
const WhyChooseUs = () => {
  const reasons = [{
    icon: <ShieldCheckIcon size={36} className="text-red-600" data-id="element-288" />,
    title: 'Reliable Service',
    description: 'With years of experience in the travel industry, we provide dependable service that you can trust.'
  }, {
    icon: <ThumbsUpIcon size={36} className="text-red-600" data-id="element-289" />,
    title: 'Best Value',
    description: 'We negotiate the best rates with our partners to offer competitive prices without compromising quality.'
  }, {
    icon: <HeartIcon size={36} className="text-red-600" data-id="element-290" />,
    title: 'Personalized Experience',
    description: 'We tailor each trip to your preferences, ensuring a unique and memorable travel experience.'
  }, {
    icon: <TrophyIcon size={36} className="text-red-600" data-id="element-291" />,
    title: 'Award-Winning Service',
    description: 'Our commitment to excellence has earned us recognition in the travel industry.'
  }, {
    icon: <StarIcon size={36} className="text-red-600" data-id="element-292" />,
    title: 'Expert Guidance',
    description: 'Our travel specialists have extensive knowledge and first-hand experience of the destinations we offer.'
  }, {
    icon: <BriefcaseIcon size={36} className="text-red-600" data-id="element-293" />,
    title: '24/7 Support',
    description: 'Our dedicated team is available around the clock to assist you before, during, and after your journey.'
  }];
  return <section className="py-16 bg-white" data-id="element-294">
      <div className="container mx-auto px-4" data-id="element-295">
        <div className="text-center mb-12" data-id="element-296">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-297">
            Why Choose Forsa Co.
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-298">
            We strive to provide exceptional travel experiences with
            personalized service and attention to detail. Here's why travelers
            choose us for their adventures:
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-299">
          {reasons.map((reason, index) => <div key={index} className="bg-gray-50 p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-300">
              <div className="mb-4" data-id="element-301">{reason.icon}</div>
              <h3 className="text-xl font-semibold mb-3 text-gray-900" data-id="element-302">
                {reason.title}
              </h3>
              <p className="text-gray-600" data-id="element-303">{reason.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
};
export default WhyChooseUs;